import type { SiteContent } from '../../types'

/*
 * organic-seeds site content.
 * Real identity values established in Phase 2.
 */
export const content: SiteContent = {
  name: 'Organic Seeds',
  legalName: 'Organic Seeds – Otmar Albert Pusch',
  tagline: 'Premium Hanfsamen & Zubehör',
  logo: '/organic-seeds-logo.png',
  contact: {
    email: 'office@stamm-baum.at',
    phone: '+43 1 341 91 85',
    address: {
      street: 'Meinhartsdorfergasse 10/2',
      postalCode: '1150',
      city: 'Wien',
      country: 'AT',
    },
  },
  legal: {
    // Austrian legal entity attributes — wired to views, values pending owner input
    uid: 'ATU82751425',
    registerNumber: '',
    trade: 'Handel mit Waren aller Art',
    managingDirector: '',
    chamber: 'Wirtschaftskammer Wien',
  },
  social: {
    instagram: '',
    facebook: '',
  },
  meta: {
    titleTemplate: '%s | Organic Seeds',
    defaultDescription: 'Organic Seeds — Hochwertige Hanfsamen, Stecklinge und Zubehör.',
    ogImage: '/organic-seeds-logo.png',
  },
}
